(() => {
	const initializeBackToTop = () => {
		if (customElements.get('back-to-top')) return;

		class BackToTop extends HTMLElement {
			constructor() {
				super();
				this.pageHeight = window.innerHeight;
				this.isVisible = false;
				this.updatePending = false;
				this.onClick = this.onClick.bind(this);
				this.requestVisibilityUpdate = this.requestVisibilityUpdate.bind(this);
			}

			connectedCallback() {
				this.addEventListener('click', this.onClick);
				window.addEventListener('scroll', this.requestVisibilityUpdate, { passive: true });
				this.requestVisibilityUpdate();
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.onClick);
				window.removeEventListener('scroll', this.requestVisibilityUpdate);
			}

			requestVisibilityUpdate() {
				if (this.updatePending) return;
				this.updatePending = true;

				requestAnimationFrame(() => {
					const shouldBeVisible = window.scrollY > this.pageHeight;
					if (shouldBeVisible !== this.isVisible) {
						this.isVisible = shouldBeVisible;
						this.classList.toggle('back-to-top--active', shouldBeVisible);
					}
					this.updatePending = false;
				});
			}

			onClick() {
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}

		customElements.define('back-to-top', BackToTop);
	};

	window.addEventListener('scroll', initializeBackToTop, {
		once: true,
		passive: true
	});
})();
